import { useTranslation } from "src/hooks";
import { TableColumnKey } from "src/views/WalletManagement/WalletBalanceMonitor/types/Table";
import { AddWalletBalanceMonitorFields } from "../../..";
import { Dispatch, SetStateAction } from "react";
import { Box } from "src/components/MuiGenerals";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import LowerThresholdTextField from "src/components/Common/BalanceThresholdInput/LowerThresholdTextField";
import UpperThresholdTextField from "src/components/Common/BalanceThresholdInput/UpperThresholdTextField";

function ThresholdFieldSection({
  fields,
  setFields,
  isLowerThresholdInvalid,
  isUpperThresholdInvalid,
}: {
  fields: AddWalletBalanceMonitorFields;
  setFields: Dispatch<SetStateAction<AddWalletBalanceMonitorFields>>;
  isLowerThresholdInvalid: boolean;
  isUpperThresholdInvalid: boolean;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const array = [
    {
      label: t(TableColumnKey.ThresholdLower),
      component: (
        <LowerThresholdTextField
          value={fields.thresholdLower}
          onChange={(value) =>
            setFields((prev) => ({ ...prev, thresholdLower: value }))
          }
          isInvalid={isLowerThresholdInvalid}
        />
      ),
    },
    {
      label: t(TableColumnKey.ThresholdUpper),
      component: (
        <UpperThresholdTextField
          value={fields.thresholdUpper}
          onChange={(value) =>
            setFields((prev) => ({ ...prev, thresholdUpper: value }))
          }
          isInvalid={isUpperThresholdInvalid}
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: "44%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      {array.map((item, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "0.5fr 1fr",
            gap: "16px",
            alignItems: "end",
          }}
        >
          <div style={{ fontSize: "12px", lineHeight: "2rem" }}>
            {item.label}
          </div>
          {item.component}
        </div>
      ))}
    </Box>
  );
}

export default ThresholdFieldSection;
